import { render, staticRenderFns } from "./ConsumerAgreement.vue?vue&type=template&id=5027b006&scoped=true"
import script from "./ConsumerAgreement.vue?vue&type=script&lang=js"
export * from "./ConsumerAgreement.vue?vue&type=script&lang=js"
import style0 from "./ConsumerAgreement.vue?vue&type=style&index=0&id=5027b006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5027b006",
  null
  
)

export default component.exports